import { ISbNode, RichTextSchema } from '@storyblok/js';
import { storyblokImageSizes } from '../consts';
import { getHeadingAnchor } from './get-header-anchor';

const pick = function (attrs: Attrs, allowed: string[]) {
  const h = {} as Attrs;

  for (const key in attrs) {
    const value = attrs[key];
    if (allowed.indexOf(key) > -1 && value !== null) {
      h[key] = value;
    }
  }
  return h;
};

type Attrs = {
  [key: string]: string | number | Array<unknown>;
};

RichTextSchema.nodes['imageCaption'] = () => {
  return {
    tag: [
      {
        tag: 'div',
        attrs: {
          class: 'storyblok-inline-image-caption',
        },
      },
    ],
  };
};

RichTextSchema.nodes.heading = (node: ISbNode) => {
  return {
    tag: [
      {
        tag: `h${node.attrs.level}`,
        attrs: {
          id: getHeadingAnchor(node.attrs.level, node.content.map(item => item?.['text']).join('')),
          class: 'storyblok-heading',
        },
      },
    ],
  };
};

RichTextSchema.nodes.image = (node: ISbNode) => {
  return {
    singleTag: [
      {
        tag: 'img',
        attrs: pick(node.attrs, ['src', 'alt', 'title', 'loading', 'width', 'height', 'srcset', 'sizes']),
      },
    ],
  };
};

export const getImageWidth = (url: string) => {
  // matches /1280x960/
  const match = url.match(/\/(\d+)x\d+\//);
  if (match) return parseInt(match[1]);
};

export const getImageHeight = (url: string) => {
  // matches /1280x960/
  const match = url.match(/\/\d+x(\d+)\//);
  if (match) return parseInt(match[1]);
};

export const getPictureSourceSizes = (url: string, maxWidth: number) => {
  const imageWidth = getImageWidth(url) || Infinity;
  const sizes: number[] = [];
  for (const i in storyblokImageSizes) {
    const size = storyblokImageSizes[i];
    const nextSize = storyblokImageSizes[parseInt(i) + 1];
    const fits = !maxWidth || nextSize <= Math.min(maxWidth * 2, imageWidth * 2);
    if (!fits) continue;
    sizes.push(size);
  }
  return sizes;
};

export const customRichTextSchema = RichTextSchema;

export const minimalTextSchema = {
  nodes: {},
  marks: {},
};
